module.exports = __webpack_public_path__ + "static/media/positive-thinking.67536bba.svg";